<template>
  <Box size="tight" class="call-history-panel box--floating">
    <div class="call-history__body">
      <Box variant="brand-light">
        <ListStacked size="large" role="presentation">
          <li role="presentation">
            <MissedCallsList />
          </li>
          <li role="presentation">
            <RecentCallsList />
          </li>
        </ListStacked>
      </Box>
    </div>
  </Box>
</template>

<script>
import MissedCallsList from './MissedCallsList';
import RecentCallsList from './RecentCallsList';

export default {
  components: {
    MissedCallsList,
    RecentCallsList,
  },
};
</script>

<style lang="scss" scoped>
.call-history-panel {
  width: 700px;

  position: absolute;
  top: 100%;
  left: 0;
  z-index: -1; // Put it behind the header to hide the top shadow

  border-bottom-right-radius: $border-radius-large;
}

.call-history__body {
  max-height: calc(100vh - 150px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  border-top: 6px solid $brand-600;
  will-change: transform; // Avoid Expand animation glitch
}
</style>
